export default "__VITE_ASSET__c29777bf__"